<template>
  <Gallery
    :item-id="itemId"
    :upload-url="uploadUrl"
    :media-url="mediaUrl"
    :show-import-button="showImportButton"
  />
</template>

<script>
import Gallery from "../../components/Gallery.vue";

export default {
  name: "StockMediaPage.vue",
  props: ["itemId", "mediaUrl", "uploadUrl", "showImportButton"],
  components: {
    Gallery,
  },
};
</script>
